<template>
  <q-page padding>
    <div class="row col-12">
      <p class="text-h6 text-brand-5 text-weight-bold">
        Criação de Ativos em Massa
      </p>
    </div>

    <q-tabs
      v-model="tab"
      dense
      class="text-grey q-mt-md bg-accent"
      active-color="primary"
      indicator-color="primary"
      align="justify"
      narrow-indicator
    >
      <q-tab name="crie" label="CRIAÇÃO DE ITENS CATÁLOGO" />
      <q-tab name="crieAtivos" label="CRIAÇÃO DE ATIVOS" />
      <q-tab name="remova" label="EXCLUSÃO DE ATIVOS" />
      <q-tab
        name="associeAcessorio"
        label="ASSOCIAÇÃO ACESSÓRIO A ITEM CATÁLOGO"
      />
      <q-tab
        name="associeAtributos"
        label="ASSOCIAÇÃO ATRIBUTOS A ITEM CATÁLOGO"
      />
      <q-tab
        name="associeChecklists"
        label="ASSOCIAÇÃO CHECKLISTS A ITEM CATÁLOGO"
      />
    </q-tabs>

    <q-tab-panels v-model="tab" animated>
      <q-tab-panel name="crie">
        <div class="row col-12">
          <p class="text-h6 text-brand-5 text-weight-bold">
            CRIAÇÃO DE ITENS CATÁLOGO
            <q-icon
              style="cursor: pointer"
              name="info"
              @click="activeSlide = !activeSlide"
            />
          </p>
        </div>
        <infot-upload
          :infos="infosCrie"
          :showUnidade="false"
          :activeSlide="activeSlide"
          link="https://multpex-docs.s3.us-east-1.amazonaws.com/templates/ferramentaria/Template_atv_Criação_Itens_Catalogo.xlsx"
        />

        <UploadAtivos
          :mapeamento="'criacao_itens_catalogo'"
          :link="'https://multpex-docs.s3.us-east-1.amazonaws.com/templates/ferramentaria/Template_atv_Criação_Itens_Catalogo.xlsx'"
          title="CRIAÇÃO DE ITENS CATÁLOGO"
        />
      </q-tab-panel>

      <q-tab-panel name="crieAtivos">
        <div class="row col-12">
          <p class="text-h6 text-brand-5 text-weight-bold">
            CRIAÇÃO DE ATIVOS
            <q-icon
              style="cursor: pointer"
              name="info"
              @click="activeSlide2 = !activeSlide2"
            />
          </p>
        </div>

        <infot-upload
          :infos="infosCrieAtivos"
          :showUnidade="false"
          :activeSlide="activeSlide2"
          link="https://multpex-docs.s3.us-east-1.amazonaws.com/templates/ferramentaria/Template_atv_Criação_ativos.xlsx"
        />
        <UploadAtivos
          :mapeamento="'criacao_ativos'"
          :link="'https://multpex-docs.s3.us-east-1.amazonaws.com/templates/ferramentaria/Template_atv_Criação_ativos.xlsx'"
          title="CRIAÇÃO DE ATIVOS"
        />
      </q-tab-panel>

      <q-tab-panel name="remova">
        <div class="row col-12">
          <p class="text-h6 text-brand-5 text-weight-bold">
            EXCLUSÃO DE ATIVOS
            <q-icon
              style="cursor: pointer"
              name="info"
              @click="activeSlide3 = !activeSlide3"
            />
          </p>
        </div>

        <infot-upload
          :infos="infosRemova"
          link="https://multpex-docs.s3.us-east-1.amazonaws.com/templates/ferramentaria/Template_atv_Exclusão_ativos.xlsx"
          :showUnidade="false"
          :activeSlide="activeSlide3"
        />
        <UploadAtivos
          :mapeamento="'exclusao_ativos'"
          :link="'https://multpex-docs.s3.us-east-1.amazonaws.com/templates/ferramentaria/Template_atv_Exclusão_ativos.xlsx'"
          title="EXCLUSÃO DE ATIVOS"
        />
      </q-tab-panel>

      <q-tab-panel name="associeAcessorio">
        <div class="row col-12">
          <p class="text-h6 text-brand-5 text-weight-bold">
            ASSOCIAÇÃO ACESSÓRIO A ITEM CATÁLOGO
            <q-icon
              style="cursor: pointer"
              name="info"
              @click="activeSlide4 = !activeSlide4"
            />
          </p>
        </div>

        <infot-upload
          :infos="infosAssocieAcessorio"
          link="https://multpex-docs.s3.us-east-1.amazonaws.com/templates/ferramentaria/Template_atv_associação_acessorio_item_catalogo.xlsx"
          :showUnidade="false"
          :activeSlide="activeSlide4"
        />

        <UploadAtivos
          :mapeamento="'associacao_acessorio_item_catalogo'"
          :link="'https://multpex-docs.s3.us-east-1.amazonaws.com/templates/ferramentaria/Template_atv_associação_acessorio_item_catalogo.xlsx'"
          title="ASSOCIAÇÃO ACESSÓRIO A ITEM CATÁLOGO"
        />
      </q-tab-panel>

      <q-tab-panel name="associeAtributos">
        <div class="row col-12">
          <p class="text-h6 text-brand-5 text-weight-bold">
            ASSOCIAÇÃO ATRIBUTOS A ITEM CATÁLOGO
            <q-icon
              style="cursor: pointer"
              name="info"
              @click="activeSlide5 = !activeSlide5"
            />
          </p>
        </div>

        <infot-upload
          :infos="infosAssocieAtributos"
          link="https://multpex-docs.s3.us-east-1.amazonaws.com/templates/ferramentaria/Template_atv_associação_atributos_item_catalogo.xlsx"
          :showUnidade="false"
          :activeSlide="activeSlide5"
        />

        <UploadAtivos
          :mapeamento="'associacao_atributos_item_catalogo'"
          :link="'https://multpex-docs.s3.us-east-1.amazonaws.com/templates/ferramentaria/Template_atv_associação_atributos_item_catalogo.xlsx'"
          title="ASSOCIAÇÃO ATRIBUTOS A ITEM CATÁLOGO"
        />
      </q-tab-panel>

      <q-tab-panel name="associeChecklists">
        <div class="row col-12">
          <p class="text-h6 text-brand-5 text-weight-bold">
            ASSOCIAÇÃO CHECKLISTS A ITEM CATÁLOGO
            <q-icon
              style="cursor: pointer"
              name="info"
              @click="activeSlide6 = !activeSlide6"
            />
          </p>
        </div>

        <infot-upload
          :infos="infosAssocieChecklists"
          link="https://multpex-docs.s3.us-east-1.amazonaws.com/templates/ferramentaria/Template_atv_associação_checklist_item_catalogo.xlsx"
          :showUnidade="false"
          :activeSlide="activeSlide6"
        />

        <UploadAtivos
          :mapeamento="'associacao_checklists_item_catalogo'"
          :link="'https://multpex-docs.s3.us-east-1.amazonaws.com/templates/ferramentaria/Template_atv_associação_checklist_item_catalogo.xlsx'"
          title="ASSOCIAÇÃO CHECKLISTS A ITEM CATÁLOGO"
        />
      </q-tab-panel>
    </q-tab-panels>
  </q-page>
</template>

<script>
import InfotUpload from "../../legado/compras/components/InfotUpload.vue";
import UploadAtivos from "../components/UploadAtivos.vue";
import { ref } from "@vue/reactivity";
export default {
  components: { UploadAtivos, InfotUpload },

  setup() {
    const activeSlide = ref(false);
    const activeSlide2 = ref(false);
    const activeSlide3 = ref(false);
    const activeSlide4 = ref(false);
    const activeSlide5 = ref(false);
    const activeSlide6 = ref(false);

    const infosCrie = ref([
      {
        name: "As colunas A, B e D são obrigatórias.",
        icon: "warning",
      },
      {
        name: "A informação de Grupo e Subgrupo é criada se não existir no primeiro upload.",
        icon: "create",
      },
      {
        name: "Não altere a ordem das colunas nem o texto, isso trará problema na importação.",
        icon: "warning",
      },
      {
        name: "Apague as informações da linha 2 e preencha com seus valores reais.",
        icon: "delete",
      },
      {
        name: "O processamento é feito em segundo plano, e pode levar até 30 minutos, você receberá no seu email o status da importação.",
        icon: "timer",
      },
    ]);

    const infosCrieAtivos = ref([
      {
        name: "A informação de código e descrição na coluna A e B deve ser igual a um item de catálogo ja criado.",
        icon: "warning",
      },
      {
        name: "Os valores para Origem devem ser: Propria, Locada ou Consumo.",
        icon: "warning",
      },
      {
        name: "A coluna de CNPJ Fornecedor deve estar sem formatação como exemplo.",
        icon: "warning",
      },
      {
        name: "A coluna Operação deve condizer com as operações ja criadas.",
        icon: "schedule",
      },
      {
        name: "A coluna Local de Deposito deverá condizer com os locais existentes.",
        icon: "warning",
      },
      {
        name: "Não altera a ordem das colunas nem o texto, isso trará problema na importação.",
        icon: "warning",
      },
      {
        name: "Apague as informações da linha 2 e preencha com seus valores reais.",
        icon: "delete",
      },
      {
        name: "O processamento é feito em segundo plano, e pode levar até 30 minutos, você receberá no seu email o status da importação.",
        icon: "timer",
      },
    ]);

    const infosRemova = ref([
      {
        name: "A coluna exige o uuid do ativo, presente no Relatório de Ativos.",
        icon: "view_column",
      },
      {
        name: "Não altere a ordem das colunas nem o texto, isso trará problema na importação.",
        icon: "warning",
      },
      {
        name: "Apague as informações da linha 2 e preencha com seus valores reais.",
        icon: "delete",
      },
      {
        name: "O processamento é feito em segundo plano, e pode levar até 30 minutos, você receberá no seu email o status da importação.",
        icon: "timer",
      },
    ]);

    const infosAssocieAcessorio = ref([
      {
        name: "A informação de codigo e descrição na coluna A e B deve ser igual a um item ja criado.",
        icon: "view_column",
      },
      {
        name: "Não altere a ordem das colunas nem o texto, isso trará problema na importação.",
        icon: "warning",
      },
      {
        name: "Apague as informações da linha 2 e preencha com seus valores reais.",
        icon: "delete",
      },
      {
        name: "O processamento é feito em segundo plano, e pode levar até 30 minutos, você receberá no seu email o status da importação.",
        icon: "timer",
      },
    ]);

    const infosAssocieAtributos = ref([
      {
        name: "A informação de codigo e descrição na coluna A e B deve ser igual a um item ja criado.",
        icon: "view_column",
      },
      {
        name: "Não altere a ordem das colunas nem o texto, isso trará problema na importação.",
        icon: "warning",
      },
      {
        name: "Apague as informações da linha 2 e preencha com seus valores reais.",
        icon: "delete",
      },
      {
        name: "O processamento é feito em segundo plano, e pode levar até 30 minutos, você receberá no seu email o status da importação.",
        icon: "timer",
      },
    ]);

    const infosAssocieChecklists = ref([
      {
        name: "A informação de codigo e descrição na coluna A e B deve ser igual a um item ja criado.",
        icon: "view_column",
      },
      {
        name: "Se o checklist não existir, um será criado.",
        icon: "create",
      },
      {
        name: "Não altere a ordem das colunas nem o texto, isso trará problema na importação.",
        icon: "warning",
      },
      {
        name: "Apague as informações da linha 2 e preencha com seus valores reais.",
        icon: "delete",
      },
      {
        name: "O processamento é feito em segundo plano, e pode levar até 30 minutos, você receberá no seu email o status da importação.",
        icon: "timer",
      },
    ]);

    return {
      activeSlide,
      activeSlide2,
      activeSlide3,
      activeSlide4,
      activeSlide5,
      activeSlide6,
      infosCrie,
      infosCrieAtivos,
      infosRemova,
      infosAssocieAcessorio,
      infosAssocieAtributos,
      infosAssocieChecklists,
      tab: ref("crie"),
    };
  },
};
</script>

<style></style>
